import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        marginTop: 20,
    },
  })
);

export default function Loading() {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container direction="row" justify="center" alignItems="center">
      <CircularProgress />
    </Grid>
  );
}
